<alert>
</alert>

<div *ngIf="show">
  <div id="load" class="load"></div>
  <div class="spinner-protocolo">
    <mat-spinner></mat-spinner>
  </div>
</div>

<router-outlet *ngIf="!isIframe"></router-outlet>
